import type { FaireProductEntity } from "../../entity_types/product";

export const p_49ncqfqzxp: FaireProductEntity = {
  token: "p_49ncqfqzxp",
  type: "product",
  name: "Satin Maxi Slip Dress",
  brandToken: "b_m1k27vexwy",
  brandName: "Naked Zebra",
  imageUrl:
    "https://cdn.faire.com/fastly/e1ded5ffc2d096598d42da650f2f36b1feff6be1ef382d81950ca6f581e57ef5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ac56a3b4474903289b8ffd9ebd2ca8a09a9cee1bc7c12f992b8c07a68d8d28f.jpeg",
    "https://cdn.faire.com/fastly/213a479fa17451801482b6c8cddb7adea93393d947517335e793088b7af4162a.jpeg",
    "https://cdn.faire.com/fastly/218e617b718b5801795c5ab27de60aaa84e1ad9d993b7963aae4be5f4bbc0618.jpeg",
    "https://cdn.faire.com/fastly/aa1960c940f9f2f74b1f71e5225d085070da04060c5187feb4f5c5a5df195e4a.jpeg",
    "https://cdn.faire.com/fastly/b2c1e1d8af930f859a57982ed3ea84fb345bc4b742a2d7916946c86f68e7318d.jpeg",
    "https://cdn.faire.com/fastly/58049b4933cc5b2eab3671911e4dd95db231217a5c561f254d527c3bc73ee754.jpeg",
    "https://cdn.faire.com/fastly/c0a9861e0f684b6c7f778c5020d775cea28ef79df7bf1415c21b8bce30750e7a.jpeg",
    "https://cdn.faire.com/fastly/6697341beeff9f6af33164b495b048b5a7a2d9b12af2f7b10ce170d636e7d019.jpeg",
    "https://cdn.faire.com/fastly/a4fb668fc4e75469f4a912fce3f6ec0d9078e28ba3285ce98c5174a2f4891799.jpeg",
    "https://cdn.faire.com/fastly/5bbe6775d4f793b5a4fb19de43a8f6747cb0d7d474af691c525003ed7b80ae75.jpeg",
  ],
  priceDollars: 23.21,
  description:
    'The details:\n\nWomen\'s Satin Maxi Slip Dress, perfect for special occasions and date nights.\n\nLuxurious satin fabric that drapes beautifully for a flattering silhouette.\n\nSleek, minimal design for an elegant and timeless look.\n\nIdeal for an evening out, offering effortless sophistication and a chic vibe.\n\n*Not Lined\n\nFabric: Woven\n100% Polyester\nHand Wash Cold\nSizes in Pack:3S-2M-1L\n\nKlarissa\'s Size & Fit:\nModel wears size S.\nHeight 5\' 9" / 175cm \nBust 32" / 81cm \nWaist 24" / 61cm \nHip 35" / 89cm',
  tags: [],
  msrpDollars: 46.42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:34.714Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
